<template>
  <div
    class="skeleton"
    :class="{ animate }"
  >
    <slot />
    <div class="skeleton-loader" />
  </div>
</template>

<script>
export default {
  name: 'DpplSkeletonLoader',
  props: {
    animate: { type: Boolean, default: true },
  },
};
</script>

<style lang="less" scoped>
.skeleton {
  position: relative;
  overflow: hidden;

  .skeleton-loader {
    position: absolute;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      hsla(0, 0%, 100%, 0),
      hsla(0, 0%, 100%, .3),
      hsla(0, 0%, 100%, 0)
    );
  }

  &.animate {
    cursor: progress;

    .skeleton-loader {
      animation: loading 1.5s infinite;
    }
  }
}

@keyframes loading {
  100% {
    transform: translateX(100%)
  }
}

</style>
